/*
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2020-12-21 13:28:29
 * @LastEditors: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @LastEditTime: 2022-03-16 10:01:55
 * @Description: 学生页面路由
 * @FilePath: /hsylc2021/src/router/volunteer/index.js
 */
import ROLES from '@/utils/roles';
let routes = [
  {
    path: '/volunteer/application',
    name: 'volunteer-application',
    meta: {
      title: '志愿者申请'
    },
    component: () => import('views/student/Volunteer/Application')
  },
  /**
   * @description 志愿者申请
   * @function /volunteer-apply 志愿者申请
   * @param { Component } Volunteer views/student/application/Volunteer.vue
   * @param { Name } pathname volunteer-apply
   */
  {
    path: '/volunteer/apply',
    name: 'volunteer-apply',
    meta: {
      title: '志愿者申请'
    },
    component: () => import('@/views/student/application/Volunteer.vue')
  }
  // /**
  //  * @description 志愿者录取
  //  * @function /volunteer-admission 志愿者录取
  //  * @param { Component } Volunteer views/student/Admission/Volunteer
  //  * @param { Name } pathname volunteer-admission
  //  */
  // {
  //   path: '/volunteer/admission',
  //   name: 'volunteer-admission',
  //   meta: {
  //     title: '志愿者录取'
  //   },
  //   component: () => import('@/views/student/Admission/Volunteer')
  // }
];
routes = routes.map(item => {
  let ret = Object.assign({}, item);
  ret.meta = Object.assign({}, ret.meta, {
    role: ROLES.STUDENT
  });
  return ret;
});
export default routes;
